import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { Theme, useTheme } from '@material-ui/core';
import { TerminatingIcon } from '../../ReleaseDetailPage/ProvisioningCard/LatestProvisioningAccordion/Icons';
import {
  NotStartedIcon,
  ProgressErrorIcon,
  ProgressRunningIcon,
  ProgressSuccessIcon,
  TerminatedIcon,
} from '../Icons';

export function StepIcon({
  status,
  className,
}: {
  status: DagStatus;
  className?: string;
}) {
  const theme = useTheme();

  switch (status) {
    case DagStatus.PASSED:
      return (
        <ProgressSuccessIcon
          htmlColor={theme.palette.success.main}
          className={className}
        />
      );
    case DagStatus.FAILED:
      return (
        <ProgressErrorIcon
          htmlColor={theme.palette.error.main}
          className={className}
          style={{ stroke: theme.palette.error.main }}
        />
      );
    case DagStatus.TERMINATED:
      return <TerminatedIcon className={className} />;
    case DagStatus.RUNNING:
      return (
        <ProgressRunningIcon
          htmlColor={theme.palette.accent.main}
          className={className}
        />
      );
    case DagStatus.WAITING:
      return (
        <ProgressRunningIcon
          htmlColor={theme.palette.accent.main}
          className={className}
        />
      );
    case DagStatus.NOT_STARTED:
      return <NotStartedIcon className={className} />;
    case DagStatus.TERMINATING:
      return <TerminatingIcon className={className} />;
    default:
      return null;
  }
}

export function getDagStatusColor(status: DagStatus, theme: Theme) {
  switch (status) {
    case DagStatus.PASSED:
      return theme.palette.success.main;
    case DagStatus.FAILED:
      return theme.palette.error.main;
    case DagStatus.TERMINATING:
      return theme.palette.error.main;
    case DagStatus.RUNNING:
      return theme.palette.accent.main;
    default:
      return theme.palette.warning.main;
  }
}
